export default "__VITE_ASSET__Cr6PIrzb__"